import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import { ModalStyle } from "../../../../common/components/ModalStyle";
import { ViewMaintenanceData } from "../../../services/maintenanceServices/MaintenanceServices";

export default function MaintenanceViewDialog({ open, onClose, maintenanceId }) {

    const [viewData, setViewData] = useState(null);
    const [openView, setOpenView] = useState(false);
    const [viewRow, setViewRow] = useState(null);
    const charge = viewData?.charges?.[0];

    const base64ToUrl = (base64, contentType) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });

        return URL.createObjectURL(blob);
    };

    const handleDeleteDocument = (index) => {
        setViewData(prev => ({
            ...prev,
            documents: prev.documents.filter((_, i) => i !== index)
        }));
    };

    useEffect(() => {
        if (!open || !maintenanceId) return;

        const fetchViewData = async () => {
            try {
                const res = await ViewMaintenanceData(maintenanceId);
                setViewData(res?.data?.result || null);
            } catch (err) {
                console.error("View maintenance error", err);
                setViewData(null);
            }
        };

        fetchViewData();
    }, [open, maintenanceId]);


    const handleView = (row) => {
        const id = row?.Id || row?.id;
        setViewRow(id);
        setOpenView(true);
    };


    return (

        <Modal open={open}>
            <Box sx={ModalStyle} className="w-[85%] h-[85%] space-y-2" >
                <div className="flex justify-between">
                    <label className="font-semibold">
                        <span>Maintenance Details</span>
                    </label>

                    <CloseModalIcon onClick={onClose} />
                </div>

                <div>

                    {/* ================= New Maintenance Details ================= */}
                    <div className="border rounded-md bg-white mt-2">
                        <div className="bg-yellow-100 text-sm font-semibold px-3 py-2 rounded-t-md">
                            New Maintenance Details
                        </div>

                        <div className="px-3 py-3 grid grid-cols-3 gap-x-10 gap-y-2 text-sm">

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Maintenance No</span>
                                <span>:</span>
                                <span>{viewData?.maintenanceNumber ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Maintenance Date</span>
                                <span>:</span>
                                <span>{viewData?.maintenanceDate ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Service Agent</span>
                                <span>:</span>
                                <span>{viewData?.serviceAgentName ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Contact Person</span>
                                <span>:</span>
                                <span>{viewData?.contactPerson ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Next Maint. Date</span>
                                <span>:</span>
                                <span>{viewData?.nextMaintenanceDate ?? "-"}</span>
                            </div>
                        </div>
                    </div>

                    {/* ================= CALIBRATION ================= */}
                    <div className="border rounded-md bg-white mt-2">
                        <div className="bg-purple-100 text-sm font-semibold px-3 py-2 rounded-t-md">
                            Calibration
                        </div>

                        <div className="px-3 py-3 grid grid-cols-3 gap-x-10 gap-y-2 text-sm">

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Calibration Interval</span>
                                <span>:</span>
                                <span>{viewData?.calibrationInterval ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Calibration Date</span>
                                <span>:</span>
                                <span>{viewData?.calibrationDate ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Calibration Method</span>
                                <span>:</span>
                                <span>{viewData?.calibrationMethodName ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">
                                    Calibration Equ. Used
                                </span>
                                <span>:</span>
                                <span>
                                    {viewData?.calibrationEquipmentsUsed?.length
                                        ? viewData.calibrationEquipmentsUsed
                                            .map(eq => `${eq.description} (${eq.equipmentCode})`)
                                            .join(", ")
                                        : "-"}
                                </span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Adjustment</span>
                                <span>:</span>
                                <span>{viewData?.adjustment ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Certificate Number</span>
                                <span>:</span>
                                <span>{viewData?.certificateNo ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Performed By</span>
                                <span>:</span>
                                <span>{viewData?.performedBy ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Calibration Pass</span>
                                <span>:</span>
                                <span>{String(viewData?.calibrationPass)}</span>
                            </div>

                        </div>

                        <div className="flex items-center gap-4 px-3">
                            <span className="font-semibold text-sm">Standard :</span>
                        </div>
                        <div className="px-3 py-3 grid grid-cols-3 gap-x-10 gap-y-2 text-sm">

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Temperature</span>
                                <span>:</span>
                                <span>{viewData?.stdTemperature ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Voltage</span>
                                <span>:</span>
                                <span>{viewData?.stdVoltage ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">FlowRate</span>
                                <span>:</span>
                                <span>{viewData?.stdFlowRate ?? "-"}</span>
                            </div>
                        </div>


                        <div className="flex items-center gap-4 px-3">
                            <span className="font-semibold text-sm">Tolerance :</span>
                        </div>
                        <div className="px-3 py-3 grid grid-cols-3 gap-x-10 gap-y-2 text-sm">

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Temperature</span>
                                <span>:</span>
                                <span className="flex items-center gap-2">
                                    <span className="font-semibold text-gray-700">±</span>
                                    <span>{viewData?.temperatureTolerance ?? "-"}</span>
                                </span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Voltage</span>
                                <span>:</span>
                                <span className="flex items-center gap-2">
                                    <span className="font-semibold text-gray-700">±</span>
                                    <span>{viewData?.voltageTolerance ?? "-"}</span>
                                </span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">FlowRate</span>
                                <span>:</span>

                                <span className="flex items-center gap-2">
                                    <span className="font-semibold text-gray-700">±</span>
                                    <span>{viewData?.flowRateTolerance ?? "-"}</span>
                                </span>
                            </div>
                        </div>

                        <div className="px-3">
                            <div className="font-semibold text-sm mb-2">
                                Calibration Details :
                            </div>

                            <table className="w-full border border-gray-200 text-sm">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border px-3 py-2 text-left">When</th>
                                        <th className="border px-3 py-2 text-left">Temperature</th>
                                        <th className="border px-3 py-2 text-left">Voltage</th>
                                        <th className="border px-3 py-2 text-left">Flow Rate</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {viewData?.calibrationDetails?.length ? (
                                        viewData.calibrationDetails.map((item, index) => (
                                            <tr key={index} className="bg-white">
                                                <td className="border px-3 py-2">
                                                    {item.afterCalibration ? "After" : "Before"}
                                                </td>
                                                <td className="border px-3 py-2">{item.temperature}</td>
                                                <td className="border px-3 py-2">{item.voltage}</td>
                                                <td className="border px-3 py-2">{item.flowRate}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4 text-gray-500">
                                                No calibration data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="px-3 py-3 grid grid-cols-3 gap-x-10 gap-y-2 text-sm">

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Assign To Biomedical Eng.</span>
                                <span>:</span>
                                <span>{viewData?.biomedicalEngineerName ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Closed By Biomedical Eng </span>
                                <span>:</span>
                                <span>{viewData?.secondBiomedicalEngineerName ?? "-"}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Assign To Biomedical Incharge</span>
                                <span>:</span>
                                <span>{viewData?.biomedicalInchargeName ?? "-"}</span>
                            </div>
                        </div>


                    </div>

                    {/* ================= Charges ================= */}
                    <div className="border rounded-md bg-white mt-2">
                        <div className="bg-blue-100 text-sm font-semibold px-3 py-2 rounded-t-md">
                            Charges
                        </div>

                        <div className="px-3 py-3 grid grid-cols-3 gap-x-10 gap-y-2 text-sm">

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Free</span>
                                <span>:</span>
                                <span>{String(viewData?.isFree)}</span>
                            </div>

                            <div className="grid grid-cols-[150px_16px_1fr]">
                                <span className="text-gray-500 font-semibold">Under Warranty</span>
                                <span>:</span>
                                <span>{String(viewData?.underWarranty)}</span>
                            </div>
                        </div>

                        <div className="px-3 py-3 text-sm">
                            <div className="hidden md:block">
                                <table className="w-full border border-gray-200">
                                    <thead className="bg-gray-100">
                                        <tr>
                                            <th className="border px-3 py-2 text-left">Charge Name</th>
                                            <th className="border px-3 py-2 text-left">Rate</th>
                                            <th className="border px-3 py-2 text-left">Quantity</th>
                                            <th className="border px-3 py-2 text-left">Tax %</th>
                                            <th className="border px-3 py-2 text-left">Total</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {viewData?.charges?.length ? (
                                            viewData.charges.map((item, index) => (
                                                <tr key={index} className="bg-white">
                                                    <td className="border px-3 py-2">
                                                        {item.chargeName ?? "-"}
                                                    </td>
                                                    <td className="border px-3 py-2">
                                                        {item.rate ?? "-"}
                                                    </td>
                                                    <td className="border px-3 py-2">
                                                        {item.quantity ?? "-"}
                                                    </td>
                                                    <td className="border px-3 py-2">
                                                        {item.taxPercent ?? "-"}
                                                    </td>
                                                    <td className="border px-3 py-2 font-semibold">
                                                        {item.totalCharges ?? "-"}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center py-4 text-gray-500">
                                                    No charges available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                    {/* ================= Uplodas Documents/ Bills ================= */}
                    <div className="border rounded-md bg-white mt-2">
                        <div className="bg-lime-100 px-3 py-2 font-semibold text-sm">
                            Upload Documents/Bills/Invoices
                        </div>

                        <div className="px-3 py-3 space-y-2 text-sm">
                            {viewData?.documents?.length > 0 ? (
                                viewData.documents.map((doc, index) => (
                                    <div
                                        key={index}
                                        className="grid grid-cols-[180px_16px_1fr]"
                                    >
                                        <span className="text-gray-500 font-semibold">
                                            Document Type
                                        </span>
                                        <span>:</span>
                                        <span>{doc.documentType ?? "-"}</span>
                                    </div>
                                ))
                            ) : (
                                <span className="text-gray-400">No Documents</span>
                            )}
                        </div>

                        <div className="border rounded-md bg-white mt-2">
                            <div className="bg-gray-100 text-sm font-semibold px-3 py-2 rounded-t-md">
                                Documents
                            </div>

                            <div className="px-3 py-3 flex flex-wrap gap-2">
                                {viewData?.documents?.length > 0 ? (
                                    viewData.documents.map((doc, index) => {
                                        const fileUrl = base64ToUrl(doc.base64File, doc.contentType);

                                        return (
                                            <div
                                                key={index}
                                                className="flex items-center gap-2 px-3 py-1 border rounded text-sm bg-gray-50"
                                            >
                                                <a
                                                    href={fileUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-700 hover:underline max-w-[180px] truncate"
                                                >
                                                    {doc.fileName}
                                                </a>

                                                <a
                                                    href={fileUrl}
                                                    download={doc.fileName}
                                                    className="text-green-600 hover:text-green-800 font-bold"
                                                    title="Download"
                                                >
                                                    ⬇
                                                </a>

                                                <button
                                                    type="button"
                                                    onClick={() => handleDeleteDocument(index)}
                                                    className="text-red-500 hover:text-red-700 font-bold"
                                                    title="Delete"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <span className="text-gray-400 text-sm">No documents available</span>
                                )}
                            </div>
                        </div>

                    </div>

                </div>

            </Box >
        </Modal >
    );
}